import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import CustomerListUI from '../../components/accountSettings/customer/CustomerListUI'
import CustomerCreateModalSF from './../../components/accountSettings/customer/CustomerCreateModalSF';
import CustomerUpdateModalSF from './../../components/accountSettings/customer/CustomerUpdateModalSF';
import CustomerDeleteModalSF from './../../components/accountSettings/customer/CustomerDeleteModalSF';

const CustomerListPageUI = ({ context, messageList, customerList, filteredCustomerList, errorList,
    // filters
    searchFilter, onSearchFilterChange,
    // modes
    selectedCount, createMode, updateMode, deleteMode, submitted,
    // event handlers
    onRowClick, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick,
    // create customer
    onCreateCustomerClick, createCustomerMode, onCancelCreateCustomer, onCreateCustomerComplete,
    // update customer
    onUpdateCustomerClick, updateCustomerMode, onCancelUpdateCustomer, onUpdateCustomerComplete,
    // update customer
    onDeleteCustomerClick, deleteCustomerMode, onCancelDeleteCustomer, onDeleteCustomerComplete,
    //
    selectedCustomer
  }) =>
  <PrivatePageSF context={context} className='pg_acc_cust' backLink='/settings/account/fin'
    centered={!customerList || customerList.length === 0 || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_customers'>
    {
      !customerList && !(errorList && errorList.length) > 0 &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      customerList && customerList.length === 0 && !(errorList && errorList.length) > 0 &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={context.permissions && context.permissions.includes('acc_manage')}
        onCreateClick={onCreateClick}
        createLinkKey='c_create_customer'
        createDisabledMessageKey='c_no_customer_msg'
      />
    }
    {
      customerList && !(errorList && errorList.length) > 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/account/fin' messageList={messageList} titleMessageKey='c_customers' />
        <CustomerListUI
          context={context}
          customerList={filteredCustomerList}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }
    <CustomerCreateModalSF context={context} createMode={createMode}
      onCancelClick={onCancelCreateCustomer} onCreateComplete={onCreateCustomerComplete}
    />
    <CustomerUpdateModalSF context={context} updateMode={updateMode}
      onCancelClick={onCancelUpdateCustomer} onUpdateComplete={onUpdateCustomerComplete}
      customer={selectedCustomer}
    />
    <CustomerDeleteModalSF context={context} deleteMode={deleteMode}
      onCancelClick={onCancelDeleteCustomer} onDeleteComplete={onDeleteCustomerComplete}
      customer={selectedCustomer}
    />
  </PrivatePageSF>

export default CustomerListPageUI
